var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12H13C13.5523 12 14 12.4477 14 13C14 13.5128 13.614 13.9355 13.1166 13.9933L13 14H1C0.447715 14 0 13.5523 0 13C0 12.4872 0.38604 12.0645 0.883379 12.0067L1 12H13H1ZM1 8H19C19.5523 8 20 8.44772 20 9C20 9.51284 19.614 9.93551 19.1166 9.99327L19 10H1C0.447715 10 0 9.55228 0 9C0 8.48716 0.38604 8.06449 0.883379 8.00673L1 8H19H1ZM1 4H19C19.5523 4 20 4.44772 20 5C20 5.51284 19.614 5.93551 19.1166 5.99327L19 6H1C0.447715 6 0 5.55228 0 5C0 4.48716 0.38604 4.06449 0.883379 4.00673L1 4H19H1ZM1 0H19C19.5523 0 20 0.447715 20 1C20 1.51284 19.614 1.93551 19.1166 1.99327L19 2H1C0.447715 2 0 1.55228 0 1C0 0.487164 0.38604 0.0644928 0.883379 0.0067277L1 0H19H1Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionIcon);
export default __webpack_public_path__ + "static/media/description-icon.2596c3bd221d4cd099f553a496c3b8ae.svg";
export { ForwardRef as ReactComponent };